export enum SupportOptionType {
  Modal,
  LiveChat,
  Link,
}
